import { IconActivityHeartbeat, IconAlertTriangle, IconServer, IconShieldCheck } from "@tabler/icons-react";
import { ColorEnum } from "./ColorEnums";

// type StatusTypes = { [K in StatusKey]: {
//     id: K,
//     color: any,
//     title: string,
// } };

// type StatusKey = keyof typeof ActiveStatusEnum | LicenseStatusEnum | BillingStatusEnum;

export enum ActiveStatusEnum {
    ALL = 0,
    ACTIVE = 1,
    INACTIVE = 2,
}
export const ActiveStatus = {
    [ActiveStatusEnum.ALL]: {
        id: ActiveStatusEnum.ALL,
        color: ColorEnum.GRAY,
        title: "All"
    },
    [ActiveStatusEnum.ACTIVE]: {
        id: ActiveStatusEnum.ACTIVE,
        color: ColorEnum.GREEN,
        title: "Active"
    },
    [ActiveStatusEnum.INACTIVE]: {
        id: ActiveStatusEnum.INACTIVE,
        color: ColorEnum.RED,
        title: "Inactive"
    },
}

export enum LicenseStatusEnum {
    ALL = 0,
    USED = 1,
    UNUSED = 2,
}

export const LicenseStatus = {
    [LicenseStatusEnum.ALL]: {
        id: LicenseStatusEnum.ALL,
        color: ColorEnum.GRAY,
        title: "All"
    },
    [LicenseStatusEnum.USED]: {
        id: LicenseStatusEnum.USED,
        color: ColorEnum.RED,
        title: "Used"
    },
    [LicenseStatusEnum.UNUSED]: {
        id: 2,
        color: ColorEnum.GREEN,
        title: "Unused"
    },
}

export enum BillingStatusEnum {
    ALL = 0,
    PAID = 1,
    UNPAID = 2,
}

export const BillingStatus = {
    [BillingStatusEnum.ALL]: {
        id: BillingStatusEnum.ALL,
        color: ColorEnum.GRAY,
        title: "All"
    },
    [BillingStatusEnum.PAID]: {
        id: BillingStatusEnum.PAID,
        color: ColorEnum.GREEN,
        title: "Paid"
    },
    [BillingStatusEnum.UNPAID]: {
        id: BillingStatusEnum.UNPAID,
        color: ColorEnum.RED,
        title: "Unpaid"
    },
}
 
export enum InstanceStatusEnum {
    ALL = 0,
    ONLINE = 1,
    OFFLINE = 2,
}


export const InstanceStatusTextEnum = {
    [InstanceStatusEnum.ALL]: 'All',
    [InstanceStatusEnum.ONLINE]: 'Online',
    [InstanceStatusEnum.OFFLINE]: 'Offline',
}

export const InstanceStatus = {
    [InstanceStatusEnum.ALL]: {
        id: InstanceStatusEnum.ALL,
        color: ColorEnum.GRAY,
        title: InstanceStatusTextEnum[InstanceStatusEnum.ALL],
    },
    [InstanceStatusEnum.ONLINE]: {
        id: InstanceStatusEnum.ONLINE,
        color: ColorEnum.GREEN,
        title: InstanceStatusTextEnum[InstanceStatusEnum.ONLINE],
    },
    [InstanceStatusEnum.OFFLINE]: {
        id: InstanceStatusEnum.OFFLINE,
        color: ColorEnum.RED,
        title: InstanceStatusTextEnum[InstanceStatusEnum.OFFLINE],
    },
}

export const InstanceCardStatus = [
    {
        color: 'blueItem',
        title: "Total Instances",
        icon: <IconServer />,
        count: '4',
        subNotes: '1 on-premise · 3 cloud',
    },
    {
        color: 'greenItem',
        title: "Online",
        icon: <IconActivityHeartbeat />,
        count: '3',
        subNotes: '1 offline',
    },
    {
        color: 'yellowItem',
        title: "Integrity Alerts",
        icon: <IconAlertTriangle />,
        count: '2',
        subNotes: 'Instances need attention',
    },
    {
        color: 'yellowItem',
        title: "Backup Coverage",
        icon: <IconShieldCheck />,
        count: '3/4',
        subNotes: 'Auto-backup enabled',
    },
]

export enum DBBackupStatusEnum {
    ENABLED = 1,
    FAILED = 2,
    DISABLED = 3,
}

export const DBBackupStatusTextEnum = {
    [DBBackupStatusEnum.ENABLED]: 'Enabled',
    [DBBackupStatusEnum.FAILED]: 'Last Failed',
    [DBBackupStatusEnum.DISABLED]: 'Disabled',
}

export enum SchemaHealthStatusEnum {
    HEALTHY = 1,
    ISSUES = 2,
    DRIFT = 3,
}

export const SchemaHealthStatusTextEnum = {
    [SchemaHealthStatusEnum.HEALTHY]: 'Healthy',
    [SchemaHealthStatusEnum.ISSUES]: 'Issues',
    [SchemaHealthStatusEnum.DRIFT]: 'Drift',
}

export enum InstanceStoredProcedureStatusEnum {
    ALL = 0,
    VALID = 1,
    INVALID = 2,
    OUTDATED = 3,
}

export const InstanceStoredProcedureStatusTextEnum = {
    [InstanceStoredProcedureStatusEnum.ALL]: 'Total',
    [InstanceStoredProcedureStatusEnum.VALID]: 'Valid',
    [InstanceStoredProcedureStatusEnum.INVALID]: 'Invalid',
    [InstanceStoredProcedureStatusEnum.OUTDATED]: 'Outdated',
}

export const SpStatus = [
    {
        id: InstanceStoredProcedureStatusEnum.ALL,
        title: InstanceStoredProcedureStatusTextEnum[InstanceStoredProcedureStatusEnum.ALL],
        count: 0,
    },
    {
        id: InstanceStoredProcedureStatusEnum.VALID,
        title: InstanceStoredProcedureStatusTextEnum[InstanceStoredProcedureStatusEnum.VALID],
        count: 0,
    },
    {
        id: InstanceStoredProcedureStatusEnum.OUTDATED,
        title: InstanceStoredProcedureStatusTextEnum[InstanceStoredProcedureStatusEnum.OUTDATED],
        count: 0,
    },
    {
        id: InstanceStoredProcedureStatusEnum.INVALID,
        title: InstanceStoredProcedureStatusTextEnum[InstanceStoredProcedureStatusEnum.INVALID],
        count: 0,
    },
];

export enum InstanceQueryTypeEnum {
    INSTANCES = 1,
    STORED_PROCEDURES = 2,
    ACTIVITY_LOGS = 3,
    AUTO_BACKUP = 4,
    DATABASE_INSTANCES = 5,
}

export enum InstanceAutoBackupTypeEnum {
    AUTOMATIC = 1,
    MANUAL = 2,
}

export const InstanceAutoBackupTypeTextEnum = {
    [InstanceAutoBackupTypeEnum.AUTOMATIC]: 'Automatic',
    [InstanceAutoBackupTypeEnum.MANUAL]: 'Manual',
}

export enum InstanceAutoBackupStatusEnum {
    SUCCESS = 1,
    FAILED = 2,
}

export const InstanceAutoBackupStatusTextEnum = {
    [InstanceAutoBackupStatusEnum.SUCCESS]: 'Success',
    [InstanceAutoBackupStatusEnum.FAILED]: 'Failed',
}

export enum InstanceBackupConfigFrequencyEnum {
    DAILY = 1,
    WEEKLY = 2,
    MONTHLY = 3,
    EVERY_SIX_HOURS = 4,
    EVERY_TWELVE_HOURS = 5,
}

export const InstanceBackupConfigFrequencyTextEnum = {
    [InstanceBackupConfigFrequencyEnum.DAILY]: 'Daily',
    [InstanceBackupConfigFrequencyEnum.WEEKLY]: 'Weekly',
    [InstanceBackupConfigFrequencyEnum.MONTHLY]: 'Monthly',
    [InstanceBackupConfigFrequencyEnum.EVERY_SIX_HOURS]: 'Every 6 Hours',
    [InstanceBackupConfigFrequencyEnum.EVERY_TWELVE_HOURS]: 'Every 12 Hours',
}

export enum InstanceDataModeEnum {
    ANONYMIZED = 1,
    FULL_COPY = 2,
    SCHEMA_ONLY = 3,
}

export const InstanceDataModeTextEnum = {
    [InstanceDataModeEnum.ANONYMIZED]: 'Anonymized',
    [InstanceDataModeEnum.FULL_COPY]: 'Full Copy',
    [InstanceDataModeEnum.SCHEMA_ONLY]: 'Schema Only',
}

export enum DBInstancesStatusEnum {
    PROVISIONING = 1, //blue
    READY = 2, //green
    OFFLINE = 3, //red
    FAILED = 4, //RED
    DELETED = 5,//red
    ONLINE = 6, //green
}

export const DBInstancesStatusTextEnum = {
    [DBInstancesStatusEnum.PROVISIONING]: 'Provisioning',
    [DBInstancesStatusEnum.READY]: 'Ready',
    [DBInstancesStatusEnum.OFFLINE]: 'Offline',
    [DBInstancesStatusEnum.FAILED]: 'Failed',
    [DBInstancesStatusEnum.DELETED]: 'Deleted',
    [DBInstancesStatusEnum.ONLINE]: 'Online',
}
